import { Box } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const ScheduleSectionContainer = styled(Box)`
  max-height: 500px;
  overflow: auto;
`
